export default __webpack_public_path__ + "static/media/DOGE.114047c5.svg";